/**
 * The built-in affirmations, and the daily pick.
 *
 * Both are ported from the phone: the list is DashboardScreen's AFFIRMATIONS
 * constant, and `dailyIndex` is affirmationService.getDailyAffirmation's
 * rotation. Keeping the same rotation matters more than it looks -- open the
 * app on your phone and then on the web on the same day and you should be shown
 * the same line, not two different ones.
 */
export const DEFAULT_AFFIRMATIONS = [
  'You are capable of amazing things 💫',
  'Today is full of possibilities 🌟',
  'You are stronger than you think 💪',
  'Every step forward is progress 🚀',
  'You deserve success and happiness ✨',
  'Challenges are opportunities to grow 🌱',
  'Your potential is limitless 🎯',
  'You are exactly where you need to be 🧭',
  'Small progress is still progress 📈',
  'You have the power to create change 🔥',
  'Today you choose courage over comfort 🦁',
  'Your dreams are worth pursuing 🌈',
  'You are worthy of love and respect 💖',
  'Focus on progress, not perfection 🎨',
  'You can handle whatever comes your way 🛡️',
  'Your best is enough 🌟',
  'Trust the process and be patient 🕰️',
  'You are making a difference 🌍',
  'Believe in yourself and your journey 🚶',
  'Today is a new opportunity to shine ☀️',
];

/**
 * Which one today is, for a list of `length`.
 *
 * The phone's formula exactly: whole days since the epoch, modulo the count.
 * It is UTC-based rather than local, which means the line can turn over at
 * midnight UTC rather than local midnight -- but it is what the phone does, and
 * matching it is worth more here than being right in isolation, because the two
 * disagreeing is what a user would actually notice.
 */
export const dailyIndex = (length: number): number => {
  if (length <= 0) return 0;
  const daysSinceEpoch = Math.floor(Date.now() / (1000 * 60 * 60 * 24));
  return daysSinceEpoch % length;
};
